
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/persona/done",
      function () {
        return require("private-next-pages/download/persona/done/index.tsx");
      }
    ]);
  